<template>
  <div v-for="(audit, index) in auditsDataAfficher" v-bind:key="audit.cle" class="row ligne-audit-changement">
    <div class="col text-left">
      <div v-if="index === 0" class="row large-600 bold">Enregistrement courant</div>
      <div v-if="audit.modifieLe" class="row large-600 bold">Informations enregistrées le : {{
          $commun.formatDateHeure(audit.modifieLe)
        }}
      </div>      
      <div v-else class="row large-600 bold">Informations enregistrées le : {{
          $commun.formatDateHeure(narration.creerLe)
        }}
      </div>
      <div v-if="audit.changeParEntite" class="row large-600 bold">
        Par : {{ audit.changeParEntite.nomIntervenant?.trim() }}, {{ audit.changeParEntite.prenomIntervenant?.trim() }},
        {{ audit.changeParEntite.nomGroupeSecurite?.trim() }}
      </div>
      <div v-else-if="narration.creerParEntite" class="row large-600 erreur bold">
        Par : {{ narration.creerParEntite.nomIntervenant?.trim() }}, {{ narration.creerParEntite.prenomIntervenant?.trim() }}, {{ narration.creerParEntite.nomGroupeSecurite?.trim() }}
      </div>
      <div v-else class="row large-600 erreur bold">
        Intervenant(e) inconnu(e)...</div>

      <div v-for="field in AUDIT_FIELDS" v-bind:key="field" class="row">
        <div class="col-5">{{ FIELD_LABELS[field] }} : </div>
        <div class="col text-center"><div v-if="audit[field].isModifie">{{ this.MODIFIED_ARROW }}</div></div>
        <div class="col">{{ audit[field].texte }}</div>
      </div>
    </div>
  </div>

  <h3>Nombre de modifications : {{ nombreModifications }}</h3>
</template>

<script>
import axios from 'axios';
import { mapGetters } from "vuex";

export default {
  name: "TableModifications",
  emits: ["isDataLoaded", "backendError"],
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$store
      .dispatch("narration/obtenirAuditsAction", {
        cle: this.$route.params.cle,
        site: this.$route.params.site,
      })
      .then((res) => {
        this.auditsData = res.data.entite.audits
        if (res.data.entite.audits !== null && res.data.entite.audits.length > 0) {
          this.auditsDataAfficher = this.formatterAudits(res.data.entite.audits)
        } else {
          this.auditsDataAfficher = this.formatterAucunAudit();
        }
      })
      .catch((err) => {
        this.$emit("backendError", err);
      })
      .finally(() => {
        this.$emit("isDataLoaded", true);
      });
  },
  data() {
    return {
      auditsData: [],
      auditsDataAfficher: [],
      isDataLoaded: false,
      MODIFIED_ARROW: "🢂",
      AUDIT_FIELDS: [
          "montant",
          "temps",
          "rapporteParDescription",
          "confidentialiteAfficher",
          "numeroSequence",
          "siteAfficher",
          "approuveParDescription",
          "approuveLe",
      ],
      FIELD_LABELS: {
          "montant": "Montant",
          "temps": "Temps consacré",
          "rapporteParDescription": "Rapporté par",
          "confidentialiteAfficher": "Confidentialité",
          "numeroSequence": "Numéro séquentiel",
          "siteAfficher": "Site d'origine",
          "approuveParDescription": "Approbateur",
          "approuveLe": "Date d'approbation",
      },
    };
  },
  computed: {
    ...mapGetters({
        //nom: "narration/nom",
        jeton: "cardex/jeton",
      profil: 'cardex/profil',
        narration: "narration/narration",
    }),
    nombreModifications() {
      return this.auditsData.length;
    },
    createur() {
      return this.narration.creerParDescription
    },
    dateCreation() {
      return this.narration.creerLe
    },
  },
  methods: {
    formatterAudits(listeAudits) {
      let listeAffichage = []
      let auditPrecedent = null

      // pour bâtir la diff, il faut revenir en arrière en commençant par
      // l'enregistrement le plus vieux
      listeAudits.sort((a,b) => {
        return new Date(a.modifieLe) - new Date(b.modifieLe)
      });

      // par design, on veut afficher les info actuelles dans le dernier enregistrement.
      // on pousse donc artificiellement un "audit" avec les infos actuelles du narration
      listeAudits.push({
          "montant": this.narration.montant,
          "temps": this.narration.temps,
          "rapporteParDescription": this.narration.rapporteParDescription,
          "confidentialiteAfficher": this.narration.confidentialiteAfficher,
          "numeroSequence": this.narration.numeroSequence,
          "siteAfficher": this.narration.siteAfficher,
          "approuveParDescription": this.narration.approuveParDescription,
          "approuveLe": this.narration.approuveLe,
          "changeParEntite": this.narration.changeParEntite,
      })

      listeAudits.forEach((audit, index) => {
        let auditAffichage = {}
        this.AUDIT_FIELDS.forEach(field => {
          auditAffichage[field] = { texte: audit[field], isModifie: false, }
          if (auditPrecedent
            && auditPrecedent[field].texte !== auditAffichage[field].texte) {
              auditAffichage[field].isModifie = true
            }
        })

        // pour l'affichage, il faut comprendre que les entrées de la table
        // d'audits sauvegardent l'information du véhicule _avant_ qu'il ne change.
        // autrement dit, puisqu'on commence avec creerParEntite, les informations suivantes
        // du véhicule sont une date "en retard".
        auditAffichage.changeParEntite = index === 0
          ? this.narration.creerParEntite
          : listeAudits[index - 1].changeParEntite

        auditAffichage.modifieLe = index === 0
          ? this.narration.creerLe
          : listeAudits[index - 1].modifieLe

        auditPrecedent = auditAffichage

        console.debug(auditAffichage)
        listeAffichage.push(auditAffichage)
      })

      // par design, la liste est affichée à partir du plus récent enregistrement.
      // pour ne pas désordonner la liste finale, dans le cas vraiment weird où la
      // date de création serait plus avancée que la date du premier audit (e.g. rapporteParDescription MMK9098),
      // on shift() le premier élément avant de filter, puis on le repousse à la fin
      let tmpAuditCreationnarration = listeAffichage.shift()
      listeAffichage.sort((a,b) => {
        return new Date(b.modifieLe) - new Date(a.modifieLe)
      });
      listeAffichage.push(tmpAuditCreationnarration)

      return listeAffichage
    },
    formatterAucunAudit() {
      let listeAudits = [];
      let audit = {
        "montant": this.narration.montant,
        "temps": this.narration.temps,
        "rapporteParDescription": this.narration.rapporteParDescription,
        "confidentialiteAfficher": this.narration.confidentialiteAfficher,
        "numeroSequence": this.narration.numeroSequence,
        "siteAfficher": this.narration.siteAfficher,
        "approuveParDescription": this.narration.approuveParDescription,
        "approuveLe": this.narration.approuveLe,
        "changeParEntite": this.narration.creerParEntite,
      }
      let auditAffichage = {}
      this.AUDIT_FIELDS.forEach(field => {
        auditAffichage[field] = {texte: audit[field], isModifie: false,}
      })

      auditAffichage.changeParEntite = audit.changeParEntite

      listeAudits.push(auditAffichage);
      return listeAudits;
    }
  },
};
</script>